








































import { Vue, Prop, Component } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import { EducationProtocolExportPreChecksMultiplyContractors as IResolveContractor } from "@/api-v2/labor-protection/models/education-protocol-export-pre-checks-multiply-contractors";
import { EducationProtocolExportResolveContractor as IEducationProtocolExportResolveContractor } from "@/api-v2/labor-protection/models/education-protocol-export-resolve-contractor";
import CBlock from "@/components/form/CustomPage/CBlock.vue";

@Component({
  components: { CBlock, CustomButton }
})
export default class LaborResolveContractorForm extends Vue {
  @Prop() resolveContractors!: IResolveContractor[];
  resolved = this.resolveContractors?.map(el => {
    return {
      contractors: el.contractors,
      listener: el.listener,
      contractorId: "",
      listenerId: el.listener?.id,
      protocolId: el.protocol?.id,
      protocol: el.protocol
    };
  });

  get isSaveDisabled() {
    return this.resolved?.some(el => !el.contractorId);
  }

  apply() {
    const resolved: IEducationProtocolExportResolveContractor[] = this.resolved?.map(
      el => {
        return {
          contractorId: el.contractorId,
          protocolId: el.protocolId,
          listenerId: el.listenerId
        };
      }
    );

    this.$emit("apply", resolved);
  }
}
